import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
// import HomePage from './pages/HomePage';
// import AboutPage from './pages/AboutPage';
import Dashboard from './Dashboard/Dashboard';
import Section_2 from './Section_2/Section_2';
import Section_3 from './Section_3/Section_3';
import Section_4 from './Section_4/Section_4';
import ServiceUrban from './ServiceUrban/ServiceUrban';
import Contact from './Contact/Contact';
import CustomHomes from './CustomHomes/CustomHomes';
import CommunityDevelopment from './CommunityDevelopment/CommunityDevelopment';
import Renovations from './Renovations/Renovations';
import HomeDesign from './HomeDesign/HomeDesign';
import StandardDesign from './StandardDesign/StandardDesign';
import BuildingDesign from './BuildingDesign/BuildingDesign';
import ProjectDetails from './Component/innerProjectDetails/innerProjectDetails';
import DesignSection from './Component/DesignSection';
import AboutUrbanCasa from './About/About';
import NotFound from './Component/404notfound/404notfound';
import Interior from './Interior/Interior';
import Kitchen from './Kitchen/Kitchen';
import Bathroom from './Bathroom/Bathroom';

function App() {
  return (
    <Router>
    <Layout>
      
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="Section-2" element={<Section_2 />} />
        <Route path="Section-3" element={<Section_3 />} />
        <Route path="Section-4" element={<Section_4 />} />
        <Route path="Services" element={<ServiceUrban />} />
        <Route path="contact" element={<Contact />} />
        <Route path="About-Urban-Casa" element={<AboutUrbanCasa/>} />
        <Route path="Custom-homes" element={<CustomHomes />} />
        <Route path="Community-Development" element={<CommunityDevelopment />} />
        <Route path="Renovation-Development" element={<Renovations />} />
        <Route path="HomeDesign" element={<HomeDesign />} />
        <Route path="StandardDesign" element={<StandardDesign />} />
        <Route path="BuildingDesign" element={<BuildingDesign />} />
        <Route path="InteriorDesign" element={<Interior />} />
        <Route path="RenovationDesign" element={<Renovations />} />
        <Route path="KitchenDesign" element={<Kitchen />} />
        <Route path="BathroomDesign" element={<Bathroom />} />
        <Route path="/project/:id" element={<ProjectDetails />} />
        <Route path="/designs/:category" element={<DesignSection />} />
 <Route path="*" element={<NotFound />} />
        {/* <Route path="/about" element={<AboutPage />} /> */}
      </Routes>
    </Layout>
    </Router>
  );
}

export default App;
